import React from "react";

const Loader = ({ text = "Loading..." }: { text?: string }) => {
  return (
    <div className="fixed inset-0 bg-white/50 backdrop-blur-sm flex flex-col items-center justify-center z-50">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-3"></div>
      <p className="text-blue-700 font-medium">{text}</p>
    </div>
  );
};

export default Loader;
